import { createPortal } from "react-dom";
import { useLocation, useSearchParams } from "react-router-dom";
import { weekdayJp } from "../types/public";
import { parseAdminFocusDay } from "./admin-list-filter";
import { scrollToAdminCalendar } from "./admin-scroll-focus";

export function AdminFocusDayBar() {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const focusDay = parseAdminFocusDay(searchParams.get("focus_day"));

  if (!focusDay || !location.pathname.startsWith("/admin/events")) return null;

  const clearFocus = () => {
    const next = new URLSearchParams(searchParams);
    next.delete("focus_day");
    setSearchParams(next, { replace: true });
  };

  return createPortal(
    <div className="admin-focus-day-bar" role="navigation" aria-label="表示日の移動">
      <span className="admin-focus-day-bar-label">
        一覧で表示中: <strong>{focusDay}</strong>（{weekdayJp(focusDay)}）
      </span>
      <button type="button" className="btn small" onClick={() => scrollToAdminCalendar()}>
        ↑ カレンダーに戻る
      </button>
      <button type="button" className="btn small secondary" onClick={clearFocus}>
        表示日を解除
      </button>
    </div>,
    document.body,
  );
}
